import formStyles from "@components/Form/FormFields/FormFields.module.scss";
import clsx from "clsx";
import { useState } from "react";
import IconChevron from "../../public/assets2019/img/svg/chevron.svg";
import styles from "./C283_DonateTool.module.scss";

interface DonateSelect {
  id: string;
  describeBy: string;
  onChange: Function;
  options: any; //needs changing from any to proper type;
  defaultOption: string;
}

export const DonateSelect = (props: { content: DonateSelect }) => {
  const { content } = props;

  const { id, describeBy, onChange, options, defaultOption } = content;
  const [open, setOpen] = useState(false);

  return (
    <div className="field">
      <div className={clsx(formStyles.select, styles.select, "select")}>
        <select
          id={id}
          aria-describedby={describeBy}
          className={clsx("select-option", open && "open")}
          onClick={() => {
            setOpen(!open);
          }}
          onBlur={() => {
            setOpen(false);
          }}
          onChange={(e) => {
            onChange(e);
          }}
        >
          <option value="">{defaultOption}</option>
          {options}
        </select>
        <div className={formStyles.tick}>
          <IconChevron />
        </div>
      </div>
    </div>
  );
};

export default DonateSelect;
